
import { defineComponent, reactive, ref } from 'vue';
export default defineComponent({
  name: 'Cell_json_modal',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number, Array],
      required: false,
      default: () => '',
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
  setup(props) {
    const title = ref('');
    const visible = ref(false);
    const json_obj = reactive({});

    const open = (text: any, record: any, column: any) => {
      title.value = column.title;
      visible.value = true;
      Object.assign(json_obj, text);
    };
    const onClose = () => {
      visible.value = false;
    };
    return {
      open,
      onClose,
      title,
      visible,
      json_obj,
    };
  },
});
